
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-formats/[...slug]",
      function () {
        return require("private-next-pages/ad-formats/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-formats/[...slug]"])
      });
    }
  